import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithCamelize } from "../apiTools";
import { IOverviewStats, ISecurityPrice } from "./types";

export const rootApi = createApi({
  baseQuery: baseQueryWithCamelize,
  reducerPath: "rootApi",
  tagTypes: [
    "Event",
    "AllEvents",
    "LeadershipTags",
    "UserInfo",
    "ShareholderMessagesList",
    "ShareholderSentMessage",
    "ShareholderMessage",
    "NoboCheck",
    "Question",
    "Questions",
    "ShareholderTags",
    "QuestionTagged",
    "Settings",
    "Features",
    "Disclaimer",
  ],
  endpoints: (builder) => ({
    getSecurityPrice: builder.query<ISecurityPrice, void>({
      query: () => "security/price/",
    }),
    getOverviewStats: builder.query<IOverviewStats, void>({
      query: () => "company-overview-stats/",
    }),
  }),
});

export const {
  util: { getRunningQueriesThunk },
  useGetSecurityPriceQuery,
  useGetOverviewStatsQuery,
} = rootApi;
